export default {"src":"/_next/static/media/Blockfolio.911058ad.svg","height":24,"width":122,"blurWidth":0,"blurHeight":0};